module.exports = __webpack_public_path__ + "static/media/morava.92d5ab4d.png";